import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e86b6244"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "model-tags" }
const _hoisted_2 = {
  key: 0,
  class: "model-tag model-tag-speed"
}
const _hoisted_3 = {
  key: 1,
  class: "model-tag model-tag-free"
}

import { getModelTime, getModelTags } from "@/lib/model-utils";
import { isFreeEnabled } from "@/lib/enabled-job-types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModelTags',
  props: {
    model: null
  },
  setup(__props: any) {

const displayModelTime = (time: string) => {
	const seconds = parseFloat(time);

	if (seconds < 1) return seconds.toFixed(2) + "s";
	if (seconds < 10) return seconds.toFixed(1) + "s";
	if (seconds < 100) return seconds.toFixed(0) + "s";

	return Math.floor(seconds / 60) + "m";
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getModelTags)(__props.model.type), (tag) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['model-tag', `model-tag-${tag.toLowerCase()}`])
      }, _toDisplayString(tag), 3))
    }), 256)),
    (!isNaN(_unref(getModelTime)(__props.model.type)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(displayModelTime(_unref(getModelTime)(__props.model.type))), 1))
      : _createCommentVNode("", true),
    (_unref(isFreeEnabled)(__props.model.type))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Free to try "))
      : _createCommentVNode("", true)
  ]))
}
}

})